import { Stack, colors } from '@ui-components/neo.tax';
import { ReactElement } from 'react';

interface ProgressDotsProps {
  currentStep: number;
  totalSteps: number;
}

export const ProgressDots = ({ currentStep, totalSteps }: ProgressDotsProps): ReactElement => (
  <Stack direction="row" gap={2}>
    {Array.from({ length: totalSteps }, (_, index) => {
      const backgroundColor =
        index === currentStep ? colors.blue[500] : index < currentStep ? colors.green[500] : colors.gray[300];

      return (
        <div
          key={index}
          style={{
            width: 8,
            height: 8,
            borderRadius: '50%',
            backgroundColor,
          }}
        />
      );
    })}
  </Stack>
);
